import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { LabelComponent } from "../../form/label/label.component";
import { CheckboxComponent } from "../../form/input/checkbox.component";
import { Router, RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { AuthService } from "../../../services/auth.service";
import { AlertComponent } from "../../ui/alert/alert.component";
import { ButtonComponent } from "../../ui/button/button.component";

@Component({
  selector: "app-signin-form",
  standalone: true,
  imports: [
    CommonModule,
    LabelComponent,
    CheckboxComponent,
    RouterModule,
    FormsModule,
    AlertComponent,
    ButtonComponent,
  ],
  templateUrl: "./signin-form.component.html",
  styles: ``,
})
export class SigninFormComponent {
  // expose to template
  auth = inject(AuthService);
  private router = inject(Router);

  showPassword = false;
  isChecked = false;

  username = "";
  password = "";
  loading = false;
  errorMsg = "";
  successMsg = "";

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  onSignIn() {
    this.errorMsg = "";
    this.successMsg = "";
    this.loading = true;
    console.log("username:", this.username, "password:", this.password);
    // Backend expects "username" -> use email as username
    this.auth.login(this.username, this.password, this.isChecked).subscribe({
      next: () => {
        this.loading = false;
        // Show success using AlertComponent instead of browser alert
        this.successMsg = 'Login successful';
        // Navigate shortly after showing the alert so user can notice it
        setTimeout(() => this.router.navigateByUrl("/"), 600);
      },
      error: (err) => {
        this.loading = false;
        // Basic error handling; customize as needed
        this.errorMsg =
          err?.error?.message ?? "Invalid credentials or server error.";
        console.error("Login failed", err);
      },
    });
  }
}
